import { connect } from 'react-redux';
import SubscriptionCommitButton from '../components/SubscriptionCommitButton';

const mapStateToProps = () => {
  return {
    showRecommitCTAs: window.gon.current_store.preferences.show_recommit_ctas,
  };
};

export default connect(mapStateToProps)(SubscriptionCommitButton);
